export default "__VITE_ASSET__7afb7dbe__"